import { auth0, getAccessToken as auth0GetAccessToken } from "./auth_config";
import { authGuard as auth0AuthGuard } from "@auth0/auth0-vue";

export const authPlugin = auth0;
export const authGuard = auth0AuthGuard;
export const getAccessToken = auth0GetAccessToken;
